import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IDetailModalProps } from '@/modules/wealth/types';
import {
  BaseText,
  ButtonPrimary,
  ButtonContainer,
  Heading
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'MandateDetail',
  props: {
    modalInfo: null
  },
  setup(__props: any) {



const closeModal = inject('closeDetailModal') as () => void;

return { __sfc: true,closeModal, NebraskaColors, BaseText, ButtonPrimary, ButtonContainer, Heading }
}

})